import styled from 'styled-components'

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    font-weight: var(--font-weight-light);
    font-size: 1rem;
`

export const GraphContainer = styled.div`
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
`
export const LoadingTitle = styled.div<{ size: 'sm' | 'md' }>`
    height: ${({ size }) => (size === 'sm' ? '16px' : '36px')};
    width: 337px;
    align-self: center;
    margin-bottom: 24px;
    border-radius: 16px;
`
